import { render, staticRenderFns } from "./MembersActivity.vue?vue&type=template&id=b18b0842&scoped=true"
import script from "./MembersActivity.vue?vue&type=script&lang=js"
export * from "./MembersActivity.vue?vue&type=script&lang=js"
import style0 from "./MembersActivity.vue?vue&type=style&index=0&id=b18b0842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18b0842",
  null
  
)

export default component.exports